import { render, staticRenderFns } from "./SideSubmenu.vue?vue&type=template&id=563d87d8&"
import script from "./SideSubmenu.vue?vue&type=script&lang=js&"
export * from "./SideSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports